import type { ContractParty } from '../../parties/types'
import { ROLE_ORDERER } from '../../parties/types'

export function ContractPartyRow({ party, onDelete }: {
  party: ContractParty
  onDelete: () => void
}) {
  const isOrderer = party.roleCode === ROLE_ORDERER
  return (
    <div className="flex items-center justify-between gap-3 py-1.5 border-b border-slate-100">
      <div className="text-sm">
        <span className="rounded bg-slate-100 text-slate-700 px-1.5 py-0.5 text-[10px] mr-2">
          {party.roleLabelPl}
        </span>
        <span className="font-medium">{party.customerName}</span>
      </div>
      {!isOrderer && (
        <button onClick={onDelete} className="text-[11px] text-red-600">Usuń</button>
      )}
    </div>
  )
}
